import React, { Component } from 'react'
import ProductInfo from '../../components/ProductRental/ProductInfo'
import { fetchCircle } from "../../store/my_circles/operations";
import { getCircleWithId, loadingInitialCirclesList } from "../../store/my_circles/selectors";
import { connect } from "react-redux";
import LoadingIndicator from "../../components/LoadingIndicator";
import Booking from '../../containers/Booking/Booking'
import { Translate } from 'react-redux-i18n';

class ProductRent extends Component {
    componentDidMount() {
        this.initPage();
    }
    initPage = () => {
        this.props.fetchCircle(this.props.circleId, true);
    };

    render() {
        return (
            <>
                {this.props.loadingCircle && <LoadingIndicator />}
                {!this.props.loadingCircle && this.props.circle &&
                    <div className='content-wrapper  circle-admin' >
                        <div className="wide-content">
                            <ProductInfo circle={this.props.circle} />
                            <div className="custom-card">
                                <strong><Translate value="rental.rental" /></strong>
                                <Booking successUrl={this.props.successUrl} circleId={this.props.circleId} productId={this.props.circle.products[0].guid} isRental={true} />
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}
const mapStateToProps = (state, props) => {
    return {
        circle: getCircleWithId(state, props.circleId),
        loadingCircle: loadingInitialCirclesList(state),
    };
};

const mapDispatchToProps = {
    fetchCircle,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductRent);
